import React from 'react';

const NotFound = () => {
  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <div style={styles.cardTopEdge} aria-hidden="true" />

        <p style={styles.eyebrow}>Roll call &mdash; page register</p>

        <div style={styles.entryRow}>
          <span style={styles.entryLabel}>Page requested</span>
          <span style={styles.entryValue}>{window.location.pathname}</span>
        </div>
        <div style={styles.ruleLine} aria-hidden="true" />

        <div style={styles.stampZone}>
          <h1 style={styles.code}>404</h1>
          <div style={styles.stamp} aria-hidden="true">
            absent
          </div>
        </div>

        <p style={styles.message}>
          This page didn&rsquo;t show up today. It may have moved, been renamed, or never
          existed on our register.
        </p>

        <div style={styles.actions}>
          <a href="/" style={styles.primaryBtn}>
            Back to homepage
          </a>
          <a href="/courses" style={styles.secondaryBtn}>
            View courses
          </a>
        </div>

        <p style={styles.footnote}>
          Still stuck? <a href="/contact" style={styles.footnoteLink}>Contact AnaBel Institute</a> and
          we&rsquo;ll help you find your way.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    minHeight: '80vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FBF8F2',
    padding: '40px 20px',
    fontFamily: '"Poppins", sans-serif'
  },
  card: {
    position: 'relative',
    width: '100%',
    maxWidth: '480px',
    background: '#FFFFFF',
    border: '1px solid #E8E2D4',
    borderRadius: '4px',
    padding: '40px 36px 36px',
    boxShadow: '0 1px 0 #E8E2D4, 0 12px 28px rgba(24, 0, 173, 0.06)'
  },
  cardTopEdge: {
    position: 'absolute',
    top: 0,
    left: '24px',
    right: '24px',
    height: '6px',
    background:
      'repeating-linear-gradient(90deg, transparent, transparent 6px, #E8E2D4 6px, #E8E2D4 9px)',
    borderRadius: '0 0 3px 3px'
  },
  eyebrow: {
    fontSize: '11px',
    fontWeight: 500,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: '#A39B86',
    margin: '4px 0 20px'
  },
  entryRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline',
    gap: '12px',
    fontSize: '13px'
  },
  entryLabel: {
    color: '#8A8372',
    flexShrink: 0
  },
  entryValue: {
    color: '#1800ad',
    fontFamily: '"Courier New", monospace',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    direction: 'rtl',
    textAlign: 'left'
  },
  ruleLine: {
    height: '1px',
    background: '#EFEAE0',
    margin: '14px 0 28px'
  },
  stampZone: {
    position: 'relative',
    textAlign: 'center',
    padding: '4px 0 8px'
  },
  code: {
    fontFamily: '"Georgia", serif',
    fontSize: '72px',
    fontWeight: 700,
    color: '#2B2620',
    margin: 0,
    lineHeight: 1
  },
  stamp: {
    display: 'inline-block',
    marginTop: '6px',
    padding: '3px 16px',
    border: '2px solid #d11210',
    borderRadius: '3px',
    color: '#d11210',
    fontFamily: '"Georgia", serif',
    fontWeight: 700,
    fontSize: '15px',
    letterSpacing: '0.18em',
    textTransform: 'uppercase',
    transform: 'rotate(-6deg)'
  },
  message: {
    fontSize: '14px',
    lineHeight: 1.6,
    color: '#5C564A',
    textAlign: 'center',
    margin: '26px 0 28px'
  },
  actions: {
    display: 'flex',
    gap: '10px',
    justifyContent: 'center',
    flexWrap: 'wrap'
  },
  primaryBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#d11210',
    color: '#FFFFFF',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: '13px',
    padding: '11px 22px',
    borderRadius: '8px'
  },
  secondaryBtn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'transparent',
    color: '#1800ad',
    textDecoration: 'none',
    fontWeight: 700,
    fontSize: '13px',
    padding: '11px 22px',
    borderRadius: '8px',
    border: '1px solid #1800ad'
  },
  footnote: {
    fontSize: '12px',
    color: '#A39B86',
    textAlign: 'center',
    margin: '24px 0 0'
  },
  footnoteLink: {
    color: '#1800ad',
    fontWeight: 600,
    textDecoration: 'none'
  }
};

export default NotFound;